export default __webpack_public_path__ + "3c7ea1ca1e402c0b34171cc5a8abea12.png";